import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RequestClassificationReverseService } from '../request-classification-reverse-rmk/service/request-classification-reverse.service';
import { requestClassificationInterface, solutionAreaInterface } from 'src/app/util/interfaces/requestClassification';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { Observable, Subject, debounceTime, forkJoin, lastValueFrom } from 'rxjs';
import { RequestClassificationService } from '../request-classification/service/request-classification.service';
import { classificationStep } from 'src/app/util/types/classificationStep';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'pcp-request-classification-reverse',
	templateUrl: './request-classification-reverse.component.html',
	styleUrl: './request-classification-reverse.component.scss',
})
export class RequestClassificationReverseComponent implements OnInit, OnChanges {
	@Input()
	labels: LabelsInterface = {
		lbl_geral_grupo: '',
		lbl_chamado_tipo_servico: '',
		lbl_geral_competencia: '',
		lbl_geral_natureza: '',
		lbl_geral_topico: '',
		lbl_geral_severidade: '',
		lbl_geral_selecione: '',
		lbl_geral_impacto: '',
		lbl_geral_urgencia: '',
		lbl_geral_tipo_de_risco: '',
	};

	constructor(
		private LabelsService: LabelsService,
		private ProfileService: ProfileService,
		private RequestClassificationReverseService: RequestClassificationReverseService,
		private RequestClassificationService: RequestClassificationService
	) {
		this.changeComponentClassificationIdsSubject.pipe(debounceTime(100)).subscribe(() => {
			this.changeComponentClassificationIds();
		});
	}

	isLoadingLabels = true;
	_isLoadingNextStep = false;
	@Output() isLoadingNextStep = new EventEmitter();
	isLoadingImpactUrgency = false;

	cascateOptions: classificationStep[] = [
		'solutionArea',
		'serviceType',
		'scope',
		'category',
		'topic',
		'severity',
		'changeType',
		'riskType',
	];
	cascateLevel = -1;
	isCascating = false;
	serviceTypeMemory = '';

	@Input() setIdSolutionArea: string;
	@Input() setIdServicetype: string;
	@Input() setIdScope: string;
	@Input() setIdCategory: string;
	@Input() setIdTopic: string;
	@Input() setIdImpact: string;
	@Input() setIdUrgency: string;
	@Input() setIdSeverity: string;

	@Input() isEditingClassification = true;
	@Input() disabled = false;
	@Input() customerList = null;
	@Input() lockField: classificationStep[] = [];
	@Input() hideField: classificationStep[] = [];
	@Input() alertField: classificationStep[] = [];
	@Input() initOn: classificationStep = 'solutionArea';
	@Input() onMe = false; //Esse parâmetro faz retornar o grupo inicial apenas grupos que estão vinculados ao meu analista
	@Input() allCustomer = false;
	@Input() definedUrgency = false; //Retorna apenas classificações que tem urgência definida
	@Input() resetWhenBacktrack = true; //Reseta os valores selecionados quando seleciona uma nova classificação, se não mantém e tenta ver se a nova classificação possui os valores antigos.

	@Output() getClassification = new EventEmitter();
	@Output() wasClassificationEditedAfterLoad = new EventEmitter();
	@Output() isClassificationFulfilled = new EventEmitter();

	availableClassification: requestClassificationInterface = {
		solutionArea: [],
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		impact: [],
		urgency: [],
		severity: [],
		riskType: [],

		solutionAreaIAC: [],
		serviceTypeIAC: [],
		scopeIAC: [],
		categoryIAC: [],
		topicIAC: [],
		impactIAC: [],
		urgencyIAC: [],
		severityIAC: [],
		riskTypeIAC: [],
	};
	selectedClassification: requestClassificationInterface = {
		solutionArea: [],
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		impact: [],
		urgency: [],
		impactIAC: [],
		urgencyIAC: [],
		severity: [],
		riskType: [],
	};
	classificationDictionary = {
		solutionArea: {},
		serviceType: {},
		scope: {},
		category: {},
		topic: {},
		impact: {},
		urgency: {},
		severity: {},
		riskType: {},
	};

	nextStep = {
		solutionArea: 'serviceType',
		serviceType: 'scope',
		scope: 'category',
		category: 'topic',
	};

	ngOnInit(): void {
		this._isLoadingNextStep = true;
		this.isLoadingNextStep.emit(true);
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		if (this.customerList == undefined) this.customerList = this.ProfileService.userData().idCustomer;

		this.RequestClassificationReverseService.getSolutionAreas(
			this.customerList,
			this.onMe,
			this.allCustomer,
			this.definedUrgency,
			[]
		).subscribe({
			next: (solutionAreaRes) => {
				for (const sa of solutionAreaRes) {
					const newSaIAC: iacOptionInterface = {
						name: sa.name,
						value: sa.id,
					};

					this.classificationDictionary['solutionArea'][sa.id] = sa;
					this.availableClassification.solutionAreaIAC.push(newSaIAC);
				}
				this.availableClassification.solutionArea = solutionAreaRes;

				if ((this.initOn && this.initOn != 'solutionArea') || (this.initOn == 'solutionArea' && this.setIdSolutionArea != '')) {
					this.cascateLevel = this.cascateOptions.indexOf(this.initOn);
					this.cascateInit();
				}

				this.availableClassification.riskType = [
					{ id: '0', label: 'Normal', name: 'Normal' },
					{ id: '1', label: 'Emergencial', name: 'Emergencial' },
					{ id: '2', label: 'Fast', name: 'Fast' },
				];

				this.availableClassification.riskTypeIAC = this.availableClassification.riskType.map((type) => ({
					name: type.name,
					value: type.id,
				}));
			},
			complete: () => {
				this._isLoadingNextStep = false;
				this.isLoadingNextStep.emit(false);
			},
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.isEditingClassification) this.wasClassificationEditedAfterLoad.emit(false);
		if (changes && changes._isLoadingNextStep) this.isLoadingNextStep.emit(this._isLoadingNextStep);
		if (
			(changes['setIdSolutionArea'] && !changes.setIdSolutionArea.isFirstChange()) ||
			(changes['setIdServicetype'] && !changes.setIdServicetype.isFirstChange()) ||
			(changes['setIdScope'] && !changes.setIdScope.isFirstChange()) ||
			(changes['setIdCategory'] && !changes.setIdCategory.isFirstChange()) ||
			(changes['setIdTopic'] && !changes.setIdTopic.isFirstChange()) ||
			(changes['setIdImpact'] && !changes.setIdImpact.isFirstChange()) ||
			(changes['setIdUrgency'] && !changes.setIdUrgency.isFirstChange()) ||
			(changes['setIdSeverity'] && !changes.setIdSeverity.isFirstChange())
		) {
			this.changeComponentClassificationIdsSubject.next();
		}
	}

	private changeComponentClassificationIdsSubject: Subject<void> = new Subject<void>();
	changeComponentClassificationIds(): void {
		if (this.isCascating) return;
		this.cascateInit();
	}

	async setClassification(classificationStep: classificationStep, index: number, isCascate: boolean): Promise<any> {
		if (!isCascate) this.wasClassificationEditedAfterLoad.emit(true);

		this.resetAvailableClassificationUntil(classificationStep);

		if (index == -1 || index == undefined) {
			if ((this.resetWhenBacktrack == false && classificationStep != 'solutionArea') || this.resetWhenBacktrack == true) {
				this.resetSelectedClassificationUntil(classificationStep);
			}
			this.getClassification.emit(JSON.stringify(this.selectedClassification));
			this.isClassificationFulfilled.emit(false);
			this.isCascating = false;
			return;
		}

		this.selectedClassification[classificationStep][0] = JSON.parse(
			JSON.stringify(this.availableClassification[classificationStep][index])
		);

		if (
			(this.selectedClassification['topic'][0] != undefined &&
				this.availableClassification.impact.length === 0 &&
				this.availableClassification.urgency.length === 0) ||
			(this.selectedClassification['topic'][0] != undefined && this.selectedClassification['severity'][0] != undefined)
		) {
			this.isClassificationFulfilled.emit(true);
		} else {
			this.isClassificationFulfilled.emit(false);
		}

		if (classificationStep == 'topic') {
			this.isLoadingImpactUrgency = true;
			let getDefault = false;
			if (
				this.selectedClassification['serviceType'][0].id.toString() == '1' ||
				this.selectedClassification['serviceType'][0].id.toString() == '2'
			)
				getDefault = true;
			this.getImpactAndUrgency(
				getDefault,
				this.selectedClassification['topic'][0].id,
				this.selectedClassification['solutionArea'][0].id
			);
			this.isCascating = false;
			return;
		}

		if (
			classificationStep == 'impact' ||
			classificationStep == 'urgency' ||
			this.hideField.includes(this.nextStep[classificationStep])
		) {
			this._isLoadingNextStep = false;
			this.getClassification.emit(JSON.stringify(this.selectedClassification));
			this.isCascating = false;
			return;
		}

		this._isLoadingNextStep = true;
		this.isLoadingNextStep.emit(true);

		if (classificationStep == 'serviceType') {
			this.serviceTypeMemory = this.selectedClassification[classificationStep][0].id;
		}

		return await lastValueFrom(
			this.RequestClassificationReverseService.getClassification(
				this.customerList,
				this.nextStep[classificationStep],
				this.selectedClassification[classificationStep][0].id,
				this.selectedClassification['solutionArea'][0].id,
				this.definedUrgency,
				this.serviceTypeMemory
			)
		)
			.then((classificationRes) => {
				for (const res of classificationRes) {
					const newClassificationIAC: iacOptionInterface = {
						name: res.name,
						value: res.id,
					};

					this.classificationDictionary[this.nextStep[classificationStep]][res.id] = res;
					this.availableClassification[`${this.nextStep[classificationStep]}IAC`].push(newClassificationIAC);
					classificationRes;
					continue;
				}
				this.availableClassification[this.nextStep[classificationStep]] = classificationRes;
				this.getClassification.emit(JSON.stringify(this.selectedClassification));

				const nextStepValue = this.selectedClassification[this.nextStep[classificationStep]][0]?.id;
				if (nextStepValue != undefined && this.resetWhenBacktrack == false) {
					const repeatedClassification = this.availableClassification[this.nextStep[classificationStep]].find(
						(classificationItem) => {
							return classificationItem.id == nextStepValue;
						}
					);
					if (repeatedClassification == undefined) {
						this.selectedClassification[this.nextStep[classificationStep]] = [];
						this.getClassification.emit(JSON.stringify(this.selectedClassification));
						this._isLoadingNextStep = false;
						this.isLoadingNextStep.emit(false);
						return;
					}
					const repeatedClassificationIndex =
						this.availableClassification[this.nextStep[classificationStep]].indexOf(repeatedClassification);

					this.setClassification(this.nextStep[classificationStep], repeatedClassificationIndex, true);
				} else {
					this._isLoadingNextStep = false;
					this.isLoadingNextStep.emit(false);
				}
			})
			.catch(() => {
				this._isLoadingNextStep = false;
				return [];
			});
	}

	async setSeverity(): Promise<any> {
		this._isLoadingNextStep = true;
		let getDefault = false;
		if (
			this.selectedClassification['serviceType'][0].id.toString() == '1' ||
			this.selectedClassification['serviceType'][0].id.toString() == '2'
		)
			getDefault = true;
		return await lastValueFrom(
			this.RequestClassificationReverseService.getSeverity(
				this.selectedClassification.impact[0].impact,
				this.selectedClassification.urgency[0].urgency,
				getDefault,
				this.customerList
			)
		)
			.then((severityRes) => {
				for (const severity of severityRes) {
					const newSeverityIAC: iacOptionInterface = {
						name: severity.label,
						value: severity.id,
					};

					this.classificationDictionary['severity'][severity.id] = severity;
					this.availableClassification['severityIAC'].push(newSeverityIAC);
				}
				this.availableClassification['severity'] = severityRes;
				this.selectedClassification['severity'] = severityRes;
				this.getClassification.emit(JSON.stringify(this.selectedClassification));
				this.isClassificationFulfilled.emit(true);
			})
			.catch(() => {
				return [];
			})
			.finally(() => {
				this._isLoadingNextStep = false;
				this.isLoadingNextStep.emit(false);
			});
	}

	getImpactAndUrgency(getDefault: boolean, idTopic?: string, idSolutionArea?: string): void {
		this._isLoadingNextStep = true;
		forkJoin([
			this.RequestClassificationReverseService.getImpact(getDefault, idSolutionArea),
			this.RequestClassificationReverseService.getUrgency(getDefault, idTopic, idSolutionArea),
		]).subscribe({
			next: (forkRes) => {
				const impactRes = forkRes[0];
				const urgencyRes = forkRes[1];

				this.availableClassification.impact = impactRes;
				this.availableClassification.urgency = urgencyRes;
				for (const impact of impactRes) {
					const newImpactIAC: iacOptionInterface = {
						name: impact.label,
						value: impact.id,
					};
					if ((impact.default == true && !this.setIdImpact) || (this.setIdImpact && this.setIdImpact == impact.impact)) {
						this.selectedClassification.impact[0] = impact;
						this.selectedClassification.impactIAC[0] = newImpactIAC;
					}
					this.classificationDictionary['impact'][impact.id] = impact;
					this.availableClassification.impactIAC.push(newImpactIAC);

					if (this.selectedClassification.impact[0]?.impact && this.selectedClassification.urgency[0]?.urgency)
						this.setSeverity();
				}
				for (const urgency of urgencyRes) {
					const newUrgencyIAC: iacOptionInterface = {
						name: urgency.label,
						value: urgency.id,
					};
					if ((urgency.default == true && !this.setIdUrgency) || (this.setIdUrgency && this.setIdUrgency == urgency.urgency)) {
						this.selectedClassification.urgency[0] = urgency;
						this.selectedClassification.urgencyIAC[0] = newUrgencyIAC;
					}
					this.classificationDictionary['urgency'][urgency.id] = urgency;
					this.availableClassification.urgencyIAC.push(newUrgencyIAC);

					if (this.selectedClassification.impact[0]?.impact && this.selectedClassification.urgency[0]?.urgency)
						this.setSeverity();
				}
			},
			complete: () => {
				this.isLoadingImpactUrgency = false;
				this._isLoadingNextStep = false;
				this.getClassification.emit(JSON.stringify(this.selectedClassification));
			},
		});
	}

	resetSelectedClassificationUntil(step: classificationStep): void {
		switch (step) {
			case 'solutionArea': {
				this.selectedClassification.solutionArea = [];
			}
			case 'serviceType': {
				this.selectedClassification.serviceType = [];
			}
			case 'scope': {
				this.selectedClassification.scope = [];
			}
			case 'category': {
				this.selectedClassification.category = [];
			}
			case 'topic': {
				this.selectedClassification.topic = [];
			}
			case 'impact':
			case 'urgency':
			case 'severity':
		}
		this.getClassification.emit(JSON.stringify(this.selectedClassification));
	}

	resetAvailableClassificationUntil(step: classificationStep): void {
		switch (step) {
			case 'solutionArea': {
				this.classificationDictionary.serviceType = {};
				this.availableClassification.serviceType = [];
				this.availableClassification.serviceTypeIAC = [];
			}
			case 'serviceType': {
				this.classificationDictionary.scope = {};
				this.availableClassification.scope = [];
				this.availableClassification.scopeIAC = [];
			}
			case 'scope': {
				this.classificationDictionary.category = {};
				this.availableClassification.category = [];
				this.availableClassification.categoryIAC = [];
			}
			case 'category': {
				this.classificationDictionary.topic = {};
				this.availableClassification.topic = [];
				this.availableClassification.topicIAC = [];
			}
			case 'topic': {
				this.availableClassification.impact = [];
				this.availableClassification.urgency = [];
				this.availableClassification.impactIAC = [];
				this.availableClassification.urgencyIAC = [];
			}
			case 'impact':
			case 'urgency':
			case 'severity':
			case 'riskType':
		}
	}

	cascateInit(): void {
		this.isCascating = true;
		if (this.cascateLevel >= 0 && this.setIdSolutionArea?.toString().trim() != '') {
			this.setClassification(
				'solutionArea',
				this.availableClassification.solutionArea.indexOf(this.classificationDictionary['solutionArea'][this.setIdSolutionArea]),
				true
			).then(() => {
				if (this.initOn == 'solutionArea') this.isCascating = false;
				if (this.cascateLevel >= 1 && this.setIdServicetype?.toString().trim() != '') {
					this.setClassification(
						'serviceType',
						this.availableClassification.serviceType.indexOf(
							this.classificationDictionary['serviceType'][this.setIdServicetype]
						),
						true
					).then(() => {
						if (this.initOn == 'serviceType') this.isCascating = false;
						if (this.cascateLevel >= 2 && this.setIdScope?.toString().trim() != '') {
							this.setClassification(
								'scope',
								this.availableClassification.scope.indexOf(this.classificationDictionary['scope'][this.setIdScope]),
								true
							).then(() => {
								if (this.initOn == 'scope') this.isCascating = false;
								if (this.cascateLevel >= 3 && this.setIdCategory.toString().trim() != '') {
									this.setClassification(
										'category',
										this.availableClassification.category.indexOf(
											this.classificationDictionary['category'][this.setIdCategory]
										),
										true
									).then(() => {
										if (this.initOn == 'category') this.isCascating = false;
										if (this.cascateLevel >= 4 && this.setIdTopic.toString().trim() != '') {
											this.setClassification(
												'topic',
												this.availableClassification.topic.indexOf(
													this.classificationDictionary['topic'][this.setIdTopic]
												),
												true
											).then(() => {
												if (this.initOn == 'topic') this.isCascating = false;
												if (this.cascateLevel >= 5 && this.setIdSeverity.toString().trim() != '') {
													this._isLoadingNextStep = true;
													let getDefault = false;
													if (this.setIdServicetype.toString() == '1' || this.setIdServicetype.toString() == '2')
														getDefault = true;
													this.getImpactAndUrgency(getDefault);
												}
											});
										}
									});
								}
							});
						}
					});
				}
			});
		}
	}
}
